'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../lib/cn';

const labelVariants = cva(
	'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

/** Props di {@link Label}: eredita gli attributi standard di `<label>` (es. `htmlFor`). */
export interface LabelProps
	extends
		React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
		VariantProps<typeof labelVariants> {}

/** Etichetta accessibile per un campo di form: associala con `htmlFor` all'id del campo. */
const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
	({ className, ...props }, ref) => (
		<LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
	),
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
